export const moduleDevLogger = ({ on }) => {
	on('@dispatch', (state, [event, data, events]) => {
		if (event === '@changed') {
			const keys = Object.keys(data).join(', ');
			console.log(`changed: ${keys}`, state);
		} else if (typeof data !== 'undefined') {
			console.log(`action: ${event}`, data);
		} else {
			console.log(`action: ${event}`);
		}
	});
}